<script setup>
defineProps({
  headerTag: {
    type: String,
    default: 'header'
  }
})
defineOptions({
  inheritAttrs: false
})
</script>

<template>
  <li role="presentation">
    <component
      :is="headerTag"
      v-bind="$attrs"
      class="t-dropdown-header"
    >
      <slot></slot>
    </component>
  </li>
</template>

<style scoped lang="scss">
.t-dropdown-header {
  display: block;
  margin: 0.5rem 0;
  color: var(--p-surface-500);
  white-space: nowrap;
}
</style>
